<script lang="ts">
  import Textfield from '@smui/textfield';
  import type { ErrorSchema, UserData } from '../types';

  import SimpleForm from './SimpleForm.svelte';

  export let submit: (event: Event) => void;
  export let formData: {
    email: string,
    password: string,
  } = {
    email: "",
    password: "",
  }
  export let errors: ErrorSchema<UserData>;
</script>

<SimpleForm errors={errors} submit={submit}>
  <Textfield
    label="Email"
    variant="outlined"
    bind:value={formData.email}
  />

  <Textfield
    label="Password"
    type="password"
    variant="outlined"
    bind:value={formData.password}
  />
</SimpleForm>
